import React from "react";
import { personal } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
    const { t } = useLanguage();
    return (
        <footer className="footer">
            <p>
                © {new Date().getFullYear()} {personal.name} — {t.footer.rights}
            </p>
        </footer>
    );
}
